import React from 'react';
import { animated } from 'react-spring';
import type { ActivityV2 } from '../../../types';
import BaseEventCard from '../../BaseEventCard';
import Block from '../../Block';
import SendEmail from '../../Cards/SendEmail';
import Task from '../../Cards/Task';
import TimelineWrapper from '../../TimelineWrapper';
import StartLfaRequestButton from '../../StartLfaRequestButton';
import type { EventTimelineContact } from '../../..';

type Props = {
  data: ActivityV2;
  style: any;
  contact?: EventTimelineContact;
};

const Activity: React.FC<Props> = ({ data, style, contact }) => {
  const commonProps = {
    id: data.id,
    key: data.id,
  };

  if (!data) return null;

  if (contact && data.__typename === 'Event_Contact_Email') {
    return (
      <animated.div {...commonProps} style={style}>
        <TimelineWrapper icon={data.icon}>
          <SendEmail {...data} contact={contact} />
        </TimelineWrapper>
      </animated.div>
    );
  }

  if (data.__typename === 'Task_Contact') {
    return (
      <animated.div {...commonProps} style={style}>
        <TimelineWrapper icon={data.icon}>
          <Task {...data} />
        </TimelineWrapper>
      </animated.div>
    );
  }

  return (
    <animated.div {...commonProps} style={style}>
      <TimelineWrapper icon={data.icon}>
        <BaseEventCard
          {...data}
          body={
            <>
              {data.body.map(block => (
                <Block {...block} key={block.id} />
              ))}
            </>
          }
          bottomBar={
            contact && data.allowsLFACreation ? (
              <StartLfaRequestButton eventId={data.id} contactId={contact.id} />
            ) : null
          }
          dataTestId={`${data.__typename}_Card`}
        />
      </TimelineWrapper>
    </animated.div>
  );
};

export default Activity;
